import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx } from "vue"

import { getEvseBriefList } from '@/api/operation'
import { ElMessage } from 'element-plus'
import { reactive, computed, onMounted, watch } from 'vue'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent, defineProps } from 'vue'
import { throttle } from 'lodash'

const __default__ = defineComponent({
  name: 'SelectEvse',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  modelValue: {
    type: String,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  operatorID: {
    type: String,
    required: true,
  },
},
  emits: ['update:modelValue', 'submit', 'changes'],
  setup(__props, { emit }) {

const props = __props

const { t, tl } = useI18nTl('Operation')



const selected = computed({
  get() {
    return props.modelValue || ''
  },
  set(val) {
    emit('update:modelValue', val)
  },
})


// 定义变量内容
const state = reactive({
  tableData: {
    data: [] as any[],
    total: 0,
    loading: false,
    param: {
      search: '',
      page: 1,
      limit: 5,
    },
  },
})

// 获取表格数据
const getTableData = throttle((query = '') => {
  state.tableData.loading = true
  getEvseBriefList({
    operatorID: props.operatorID,
    pageReq: {
      ...state.tableData.param,
      search: query,
    },
    ID: props.modelValue || '0',
  }).then((res: any) => {
    const data = [] as any[]
    res.list.map((item: any) => {
      data.push({
        id: item.ADOID,
        name: item.ADOName,
      })
    })
    state.tableData.data = data
    state.tableData.total = Number(res.pageReply.total_rows)
    state.tableData.loading = false
  })
}, 500)

watch(
  () => props.modelValue,
  (newValue, oldValue) => {
    selected.value = newValue
    // 兼容编辑框，初始化时没有值，后续编辑赋值没有select
    if (!oldValue) {
      getTableData()
    }
  },
)
onMounted(() => {
  if (props.modelValue) {
    getTableData('')
  }
})
// 分页改变
const onHandleSizeChange = (val: number) => {
  state.tableData.param.limit = val
  getTableData()
}
// 分页改变
const onHandleCurrentChange = (val: number) => {
  state.tableData.param.page = val
  getTableData()
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createBlock(_component_el_select, {
    "value-key": "id",
    size: "default",
    modelValue: _unref(selected),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(selected) ? (selected).value = $event : null)),
    filterable: "",
    clearable: "",
    remote: "",
    disabled: __props.disabled,
    "remote-method": _unref(getTableData),
    onFocus: _cache[3] || (_cache[3] = ($event: any) => (_unref(getTableData)())),
    onClear: _cache[4] || (_cache[4] = ($event: any) => (_unref(getTableData)())),
    placeholder: _ctx.$t('Operation.selectEvse')
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).tableData.data, (item) => {
        return (_openBlock(), _createBlock(_component_el_option, {
          key: item.id,
          label: item.name,
          value: item.id
        }, null, 8, ["label", "value"]))
      }), 128)),
      _createVNode(_component_el_pagination, {
        onSizeChange: onHandleSizeChange,
        onCurrentChange: onHandleCurrentChange,
        "pager-count": 5,
        "page-sizes": [10, 20, 50, 100],
        "current-page": _unref(state).tableData.param.page,
        "onUpdate:current-page": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).tableData.param.page) = $event)),
        background: "",
        "page-size": _unref(state).tableData.param.limit,
        "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).tableData.param.limit) = $event)),
        small: "",
        layout: "prev, pager, next",
        total: _unref(state).tableData.total
      }, null, 8, ["current-page", "page-size", "total"])
    ]),
    _: 1
  }, 8, ["modelValue", "disabled", "remote-method", "placeholder"]))
}
}

})